import { formatPpaCreator } from 'utils/ppaHelpers';
import type { InternalTableRecord } from '../types';

const CreatedByCell = ({ record }: { record: InternalTableRecord }) => {
    const creator = formatPpaCreator(record.created_by);
    return (
        <div className="flex items-center gap-2">
            <span className="p-1 rounded-full bg-[#EDE8FF] text-[10px] leading-4 text-center text-[#6A5ACD] font-medium">
                {creator.initials}
            </span>
            <span className="text-[14px] text-[#3F3F46]">{creator.value}</span>
        </div>
    );
};

export default CreatedByCell;
